<template>
  <div class="chart-container">
    <v-select
      class="year-select"
      :items="anoLectivoAll"
      v-model="anoLectivoSelected"
      @change="carregarDados"
      item-value="descricao"
      item-text="novadescricao"
      label="Ano Lectivo"
      outlined
      dense
      hide-details
    ></v-select>

    <loading v-if="isLoading" />

    <bar-chart
      v-if="!isLoading && chartData"
      :chart-data="chartData"
      :options="chartOptions"
    />
  </div>
</template>

<script>
import { Bar } from 'vue-chartjs'
import axios from "../../../plugins/axios"
const ls = require('local-storage')

export default {
  name: 'MediaPorDisciplina',
  components: {
    loading: () => import("../../../components/loading.vue"),
    'bar-chart': {
      extends: Bar,
      props: ['chartData', 'options'],
      mounted() {
        this.renderChart(this.chartData, this.options)
      },
      watch: {
        chartData(newData) {
          this.renderChart(newData, this.options)
        }
      }
    }
  },
  data() {
    return {
      anoLectivoAll: [],
      anoLectivoSelected: ls.get('anolectivo'),
      mediaPorDisciplinaAll: [],
      chartData: null,
      chartOptions: {
        responsive: true,
        maintainAspectRatio: false,
        title: {
          display: true,
          text: 'Média Geral por Disciplina'
        },
        legend: {
          display: false
        },
        tooltips: {
          callbacks: {
            title: function(tooltipItems, data) {
              const index = tooltipItems[0].index
              return data.labels[index]
            }
          }
        },
        scales: {
          yAxes: [{
            ticks: {
              beginAtZero: true,
              stepSize: 1
            },
            scaleLabel: {
              display: true,
              labelString: 'Média Geral'
            }
          }],
          xAxes: [{
            ticks: {
              callback: function(value) {
                return value.length > 10 ? value.substr(0, 10) + '...' : value
              },
              autoSkip: false,
              maxRotation: 45,
              minRotation: 0
            },
            scaleLabel: {
              display: true,
              labelString: 'Disciplinas'
            }
          }]
        }
      },
      isLoading: false
    }
  },

  async created() {
    await this.carregarAnosLectivos()
    await this.carregarDados()
  },

  methods: {
    async carregarAnosLectivos() {
      this.isLoading = true
      try {
        const response = await axios.get(`/getAnosLectivosAll`)
        this.anoLectivoAll = response.data
      } catch (error) {
        console.error("Erro ao carregar anos lectivos:", error)
      } finally {
        this.isLoading = false
      }
    },

    async carregarDados() {
      this.isLoading = true
      try {
        const anolectivo = this.anoLectivoSelected || ls.get('anolectivo')
        const response = await axios.get(`/getMediaNotasPorDisc/${anolectivo}`)
        
        this.mediaPorDisciplinaAll = response.data

        this.chartData = {
          labels: this.mediaPorDisciplinaAll.map(item => item.disciplina),
          datasets: [{
            label: 'Média Geral',
            backgroundColor: '#42A5F5',
            data: this.mediaPorDisciplinaAll.map(item => item.media_geral)
          }]
        }
      } catch (error) {
        console.error("Erro ao carregar dados:", error)
      } finally {
        this.isLoading = false
      }
    }
  }
}
</script>

<style scoped>
.chart-container {
  max-width: 900px;
  margin: 0 auto;
  padding: 20px;
  background-color: #fff;
}
.year-select {
  margin-bottom: 20px;
}
</style>
